import { Box } from '@chakra-ui/core'
import React from 'react'
import { EvidenceEntity, TaskDefinitionEntity, Maybe } from '../../../../generated/graphql'
import DataFieldsForm from './DataFieldsForm'

type ReportFormProps = {
  task: Maybe<TaskDefinitionEntity>
  evidence?: Maybe<EvidenceEntity>
  editedFrom?: string
}

const ReportForm: React.FC<ReportFormProps> = ({ task, evidence, editedFrom }) => {
  return (
    <Box pb={24}>
      <DataFieldsForm evidence={evidence} task={task} editedFrom={editedFrom} />
    </Box>
  )
}

export default ReportForm
